export const SERVER_AUTH = 'https://api.ecommerce.neon-xpress.com/v1';
export const SERVER_MAHAMART = 'https://api.ecommerce.neon-xpress.com';
export const SERVER_LGS = 'https://api.logistics.neon-xpress.com';
export const AUTH_UI_URL = 'http://localhost:3005';
export const SERVER_ELGS = 'https://api-elgs.laconic.co.th';
